(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports"], b);else if ("undefined" != typeof exports) b(exports);else {
    var c = {
      exports: {}
    };
    b(c.exports), a.translate = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a) {
  "use strict";

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.default = void 0;

  a.default = function () {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (b) {
      var c = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return Object.keys(c).reduce(function (a, b) {
        return a.replace(new RegExp("{{".concat(b, "}}"), "g"), c[b]);
      }, c.context && a["".concat(b, "_").concat(c.context)] || a[b] || b);
    };
  };
});